var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService } from '../../../../../services/modules/brand-client.service';
import * as Enumerable from 'linq';
import { NotificationClientService, NotificationType } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { computedFrom } from 'aurelia-binding';
import { UserClaimsService } from '../../../../../services/authentication/user-claims.service';
import { LotteryPlatformClaims } from '../../../../../constants/modules/lotteryplatform.claims';
import { ConfirmationDialogModel } from '../../../../../models/lookups/lookup.models';
import { DialogServiceConstants } from '../../../../../constants/basics/dialog.constants';
var ManageLotteriesDialog = /** @class */ (function () {
    function ManageLotteriesDialog(dialogClient, brandClientService, dialogClient1, notificationService, i18N, userClaimsService) {
        this.dialogClient = dialogClient;
        this.brandClientService = brandClientService;
        this.dialogClient1 = dialogClient1;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.userClaimsService = userClaimsService;
        this.operatorLotteryPricingModels = [];
        this.isDataLoading = false;
        this.disableButtons = false;
        this.configs = [];
    }
    ManageLotteriesDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    ManageLotteriesDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var subscribedLotteries;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.disableButtons = true;
                        subscribedLotteries = Enumerable.from(this.configs).where(function (x) { return x.isSubscribed == true; });
                        if (!!(subscribedLotteries.any(function (x) { return x.shouldUsePricingFromBrand == false && x.shouldUsePricingFromOperator == false && x.isSubscribed == true; }))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.brandClientService.manageBrandLotterySubscriptions('brandId' in this.vm.item ? this.vm.item.brandId : null, this.vm.item.operatorId, subscribedLotteries.toArray()).then(function (response) {
                                _this.notificationService.show(_this.i18N.tr('manage-lotteries'), _this.i18N.tr('successfully-added-lotteries'), NotificationType.Success);
                                _this.vm.reLoad(_this.vm.item);
                                _this.dialogClient.hide();
                            }, function (e) {
                                _this.notificationService.show(_this.i18N.tr('manage-lotteries'), _this.i18N.tr('failed-adding-lotteries'), NotificationType.Error);
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.notificationService.show(this.i18N.tr('manage-lotteries'), this.i18N.tr('select-operator-or-brand'), NotificationType.Error);
                        _a.label = 3;
                    case 3:
                        this.disableButtons = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // call this function on click radio button before the action occurs. 
    ManageLotteriesDialog.prototype.validateClickEvent = function (brandLotterySubscriptionConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var confirmModel;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(brandLotterySubscriptionConfig.shouldUsePricingFromOperator || brandLotterySubscriptionConfig.shouldUsePricingFromBrand)) return [3 /*break*/, 2];
                        // call confirmation dialog with 'yes' and 'no' button
                        require("../../dialogs/confirmation-dialog");
                        confirmModel = new ConfirmationDialogModel();
                        confirmModel.headerTitle = "change-confirmation"; // confirmation message mention in en.json as "Are you sure you want to change?"
                        if (brandLotterySubscriptionConfig.shouldUsePricingFromBrand) {
                            confirmModel.headerMessage = "operatorData-override"; // this message in en.json, to alert the user that operator ticket prices, currencies are replace with brand's
                        }
                        else {
                            confirmModel.headerMessage = "brandData-override"; // this message in en.json, to alert the user that brand ticket prices, currencies are replace with operator's
                        }
                        return [4 /*yield*/, this.dialogClient.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                                confirmModel: confirmModel,
                                save: function () { return new Promise(function (resolves, reject) {
                                    if (confirmModel.headerMessage.includes("operator")) { // 'operator' key from header message from confirmation model, when click'yes' from confirmatin model to make true for operator radio button
                                        brandLotterySubscriptionConfig.shouldUsePricingFromOperator = true;
                                        brandLotterySubscriptionConfig.shouldUsePricingFromBrand = false;
                                    }
                                    else {
                                        brandLotterySubscriptionConfig.shouldUsePricingFromBrand = true;
                                        brandLotterySubscriptionConfig.shouldUsePricingFromOperator = false;
                                    }
                                    _this.dialogClient.hide(true, "alertSecondDialog");
                                    return true; // return true, change event of radio button will  take place.
                                }); },
                                hide: function () { return new Promise(function () {
                                    _this.dialogClient.hide(true, "alertSecondDialog");
                                    return false;
                                }); }
                            }, undefined, undefined, undefined, "alertSecondDialog")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, false];
                    case 2:
                        if (!brandLotterySubscriptionConfig.shouldUsePricingFromOperator && !brandLotterySubscriptionConfig.shouldUsePricingFromBrand) {
                            brandLotterySubscriptionConfig.shouldUsePricingFromBrand = true;
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, true];
                }
            });
        });
    };
    Object.defineProperty(ManageLotteriesDialog.prototype, "lotteries", {
        get: function () {
            var _this = this;
            var hasOperatorClaim = this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageOperatorLotterySubscription);
            var enumerable = Enumerable.from(this.configs);
            // if brand filter the lotteries by what is available, if operator don't.
            if (!hasOperatorClaim) {
                enumerable = enumerable.where(function (x) { return Enumerable.from(_this.availableLotteries).any(function (z) { return z == x.lotteryId; }); });
            }
            if (!this.search && !this.country)
                return enumerable.toArray();
            if (this.search)
                enumerable = enumerable.where(function (x) { return x.lotteryName.toLowerCase().indexOf(_this.search.toLowerCase()) >= 0; });
            if (this.country)
                enumerable = enumerable.where(function (x) { return x.lotteryCountryId == _this.country; });
            return enumerable.toArray();
        },
        enumerable: false,
        configurable: true
    });
    ManageLotteriesDialog.prototype.checkForSetByBrandOrOperator = function (brandLotterySubscriptionConfig) {
        if (brandLotterySubscriptionConfig.isSubscribed && !brandLotterySubscriptionConfig.shouldUsePricingFromOperator && !brandLotterySubscriptionConfig.shouldUsePricingFromBrand)
            brandLotterySubscriptionConfig.shouldUsePricingFromBrand = true;
    };
    ManageLotteriesDialog.prototype.activate = function (model) {
        var _this = this;
        if (!model)
            return;
        this.availableLotteries = Enumerable.from(model.dataGrid.getRowsCollection()).select(function (x) { return x.item.id; }).toArray();
        this.vm = model;
        this.isDataLoading = true;
        //the below will always be true though needed for typescript 
        if ('brandId' in this.vm.item) {
            this.brandClientService.getLotteryBrandSubsciptions(this.vm.item.brandId, this.vm.item.operatorId).then(function (x) {
                _this.isDataLoading = false;
                _this.configs = Enumerable.from(x.configs).orderBy(function (x) { return x.lotteryName; }).toArray();
            }).catch(function (x) { return _this.isDataLoading = true; });
        }
    };
    __decorate([
        computedFrom("configs", "availableLotteries", "search", "country"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ManageLotteriesDialog.prototype, "lotteries", null);
    ManageLotteriesDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService, BrandClientService, DialogClientService,
            NotificationClientService, I18N, UserClaimsService])
    ], ManageLotteriesDialog);
    return ManageLotteriesDialog;
}());
export { ManageLotteriesDialog };
